// extracted by mini-css-extract-plugin
module.exports = {"container":"supplier-offers-and-events_container__SGY4i","title":"supplier-offers-and-events_title__McpvV","counter":"supplier-offers-and-events_counter__cFVIf"};